module.exports = __webpack_public_path__ + "img/santander.31182c3b.svg";